import Cookies, { CookieAttributes } from 'js-cookie';

export const FUNCTIONAL_COOKIE_NAME = 'PVH_COOKIES_GDPR';
export const ANALYTICAL_COOKIE_NAME = 'PVH_COOKIES_GDPR_ANALYTICS';
export const SOCIAL_MEDIA_COOKIE_NAME = 'PVH_COOKIES_GDPR_SOCIALMEDIA';
export const DEFAULT_COOKIE_SETTINGS: CookieAttributes = {
  expires: 365 / 2, // cookies on e-com lasts 6 months
  sameSite: 'Lax',
  secure: true,
};

export type Consent = 'Accept' | 'Reject';

export type CookieConsent = {
  functional: Extract<Consent, 'Accept'>;
  analytical: Consent;
  socialMedia: Consent;
};

export const readConsentCookies = (): CookieConsent | null => {
  const functional = Cookies.get(FUNCTIONAL_COOKIE_NAME);
  const analytical = Cookies.get(ANALYTICAL_COOKIE_NAME);
  const socialMedia = Cookies.get(SOCIAL_MEDIA_COOKIE_NAME);

  return functional !== 'Accept'
    ? null
    : {
        functional: 'Accept',
        analytical: (analytical ?? 'Reject') as Consent,
        socialMedia: (socialMedia ?? 'Reject') as Consent,
      };
};

export const setConsentCookies = (updatedConsent: CookieConsent) => {
  Cookies.set(
    FUNCTIONAL_COOKIE_NAME,
    updatedConsent.functional,
    DEFAULT_COOKIE_SETTINGS
  );
  Cookies.set(
    ANALYTICAL_COOKIE_NAME,
    updatedConsent.analytical,
    DEFAULT_COOKIE_SETTINGS
  );
  Cookies.set(
    SOCIAL_MEDIA_COOKIE_NAME,
    updatedConsent.socialMedia,
    DEFAULT_COOKIE_SETTINGS
  );
};
